/**
 * URL-bound dashboard taxonomy (`tax`). Dashboard omitted default is sector.
 * Area route must not import this hook — its omitted default is industry.
 */
import { DEFAULT_TAXONOMY, TaxonomySchema, type Taxonomy } from '@meridian/contracts';

import { useSearchEnumParam } from './use-search-enum-param';

export function useTaxonomyParam(): {
  readonly tax: Taxonomy;
  readonly setTax: (tax: Taxonomy) => void;
} {
  const { value, setValue } = useSearchEnumParam('tax', TaxonomySchema, DEFAULT_TAXONOMY);
  return { tax: value, setTax: setValue };
}
